import moment from "moment"

export const calculateAge = birthDate => {
  const today = new Date()
  const birth = new Date(birthDate)
  let age = today.getFullYear() - birth.getFullYear()
  const m = today.getMonth() - birth.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    age--
  }
  return age
}

export const formatAnyTime = t => {
  if (!t) return "-"

  const formats = [
    "HH:mm",
    "HH:mm:ss",
    "hh:mm A",
    "hh:mm:ss A",
    "h:mm A", // 👈 required for “3:00 PM”
    "h:mm:ss A",
  ]

  for (let f of formats) {
    const m = moment(t, f, true)
    if (m.isValid()) {
      return m.format("hh:mm A") // Always convert to clean 12-hour
    }
  }

  // Fallback (moment auto-detect)
  const auto = moment(t)
  if (auto.isValid()) return auto.format("hh:mm A")

  return
}
